const SOCIAL_LINKS = {
	linkedin : {
		url : "https://www.linkedin.com/in/{profileId}/",
		icon: "linkedin"
	},
	twitter  : {
		url : "https://twitter.com/{profileId}",
		icon: "twitter"
	},
	facebook : {
		url : "https://fb.me/{profileId}",
		icon: "facebook"
	},
	instagram: {
		url : "https://www.instagram.com/{profileId}/",
		icon: "instagram"
	},
	gitlab   : {
		url : "https://gitlab.com/{profileId}",
		icon: "gitlab",
	},
	github   : {
		url : "http://github.com/{profileId}",
		icon: "github-circle",
	},
	pinterest: {
		url : "http://pinterest.com/{profileId}",
		icon: "pinterest"
	},
	skype    : {
		url : "skype:{profileId}?call",
		icon: "skype"
	},
	behance  : {
		url : "https://www.behance.net/{profileId}",
		icon: "behance"
	},
	medium   : {
		url : 'https://medium.com/@{profileId}',
		icon: 'medium'
	},
	whatsapp : {
		url : 'https://api.whatsapp.com/send?phone={profileId}&text=¡Hola!%20Christhoval',
		icon: 'whatsapp'
	},
	email    : {
		url : 'mailto:{profileId}?subject=¡Hola!%20Christhoval',
		icon: 'at'
	},
};

const getSocial = ({network, profileId, hide = false}, only = []) => {
	if (!SOCIAL_LINKS.hasOwnProperty(network) || !only.includes(network))
		return {
			hide: true,
			icon: 'circle',
			href: '/'
		};

	const {url, icon} = SOCIAL_LINKS[network];

	return {
		icon,
		href: url.replace('{profileId}', profileId),
		hide
	}
};

export {
	SOCIAL_LINKS,
	getSocial
}



// WEBPACK FOOTER //
// ./src/utilities/socials.js